import React, { useEffect, useState } from "react";
import HeaderNavComponenet from "../component/HeaderNavComponenet";
import {
  collection,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper";

const Activities = () => {
  const [galleryFiles, setGalleryFiles] = useState([]);
  const [openMenu, setOpenMenu] = useState(false);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [openMenuGallery, setOpenMenuGallery] = useState("");
  const [closeMenuGallery,setCloseMenuGallery] = useState("");

  useEffect(() => {
    const q = query(
      collection(db, "galleryUpload"),
      orderBy("date", "desc")
    );
    onSnapshot(q, (querySnapshot) => {
      let galleryArray = [];
      querySnapshot.forEach((doc) => {
        galleryArray.push({ id: doc.id, ...doc.data() });
      });
      setGalleryFiles(galleryArray);
    });
  }, []);

  let tempArray = galleryFiles?.filter((e) => e?.category === "Activity") 

  return (
    <React.Fragment>
      <HeaderNavComponenet />

      <div className="">
        <div className="py-7 text-center bg-[#162238]">
          <span className="text-4xl font-bold uppercase text-white">
            Session 2023-2024
          </span>
        </div>
        <div className="py-20  bg-[#162238]"></div>
        <div className="bg-white shadow-lg min-h-screen rounded-t-lg lg:p-10 p-2  lg:pr-24 lg:pl-24 ml-5 mr-5 lg:mr-24 lg:ml-24 -lg:mt-40 -mt-40">
          <div className="flex justify-between w-full bg-[#053375] rounded-md">
            <div className="text-xl font-bold text-left px-10 text-white uppercase py-2">
              School Programme
            </div>
            {/* <div className="mt-2.5 justify-items-end">
              <button>
                <img
                  src="../assets/menu.png"
                  alt="pic"
                  className="h-6 w-8 mr-2"
                />
              </button>
            </div> */}
          </div>
          
        <div className="text-lg font-bold text-center lg:p-3 mt-4">
            <div className="lg:grid lg:grid-cols-4 grid pr-2">
              {tempArray.map((item) => (
                <div
                  key={item.pictureUrl}
                  className=" bg-[#FFFFFF]  mr-2 ml-2 mb-2 rounded-lg lg:mr-2 lg:ml-2 lg:mt-2 lg:mb-2 "
                >
                  <div className=" h-full w-full" >
                    <div 
                     style={{cursor: "pointer"}}  onClick={() =>
                        setOpenMenuGallery(() => {
                          setCloseMenuGallery(false);
                          setOpenMenuGallery(true);
                        })
                      }
                      >
                    <img 
                      src={item.pictureUrl}
                      alt="pic"
                      className="object-cover lg:h-40  w-full"
                    />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      { openMenuGallery && ( <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity">
        <div className="fixed z-0  justify-center inset-0 overflow-y-auto ">
          <div className=" bg-white rounded-md  min-h-screen w-full">
            <div className="place-self-center rounded-lg  ">
              <div className="flex justify-end">
                <button
                  className=""
                  onClick={() =>
                    setOpenMenuGallery(() => {
                      setCloseMenuGallery(true);
                      setOpenMenuGallery(false);
                    })
                  }
                >
                  <img
                    src="../assets/close-button.png"
                    alt="pic"
                    className="h-10 w-10"
                  />
                </button>
              </div>
            </div>
            <div className="h-full w-full ">
              <Swiper
                loop={true}
                spaceBetween={10}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                className=""
                >
                {tempArray.map((elem,index) => (             
                  <SwiperSlide  key={index}>
                  <img
                    alt="pic"
                    src={elem.pictureUrl}
                    className=" object-contain lg:h-[36rem] h-[30rem] w-full select-none"
                  />
                </SwiperSlide>         
               ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div> 
      )}

      <footer className="border-t-2">
        <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span className="text-black text-lg font-bold hover:text-blue-300 ">
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Activities;
